import React from 'react';
/**
 * @namespace utils/validation
 */
/**
 * Validate one field for passed rule
 *
 * @memberof utils/validation
 * @async
 * @param {object} validationObj
 * @param {Array} params
 * @returns {void}
 */
const checkRules = (validationObj, params) => new Promise((resolve) => {
  let errorMsg = null;
  if (validationObj.rules.includes('mandatory') && !validationObj.value) {
    errorMsg = `${validationObj.label} is required`;
  } else if (validationObj.rules.includes('equal') && validationObj.value !== params[validationObj.equalToIndex].value) {
    errorMsg = `${validationObj.label} does not match !`;
  } else if (validationObj.rules.includes('regExp') && !RegExp(validationObj.expression).test(validationObj.value)) {
    errorMsg = `${validationObj.label} does not match requirements !`;
  } else if (validationObj.rules.includes('greaterThan') && validationObj.value <= validationObj.comparatorValue) {
    errorMsg = `${validationObj.label} should be greater than ${validationObj.comparatorValue} !`;
  } else if (validationObj.rules.includes('notLessThan') && validationObj.value < validationObj.comparatorValue) {
    errorMsg = `${validationObj.label} should not be less than ${validationObj.comparatorValue} !`;
  } else if (validationObj.rules.includes('betweenXAndY')
  && (validationObj.value < validationObj.minValue
    || validationObj.value > validationObj.comparatorMaxValue)
  ) {
    errorMsg = `${validationObj.label} should be between ${validationObj.minValue} and ${validationObj.comparatorMaxValue} !`;
  }
  if (errorMsg) {
    const error = {
      [validationObj.fieldName]: <div className="form__msg form__msg--error dialog__input-error-txt">{errorMsg}</div>,
    };
    resolve(error);
  } else {
    resolve(null);
  }
});

/**
 * Validate all fields
 *
 * @memberof utils/validation
 * @async
 * @param {Array} validationParams
 * @returns {void}
 */
const validateFields = (validationParams) => new Promise((resolve, reject) => {
  const values = validationParams.map((validationObj) => (
    checkRules(validationObj, validationParams)));
  Promise.all(values).then((val) => {
    const errors = val.filter((e) => !!e);
    if (errors.length > 0) {
      reject(errors);
    } else {
      resolve();
    }
  });
}).catch((err) => {
  let error = {};
  err.map((e) => {
    error = {
      ...error,
      ...e,
    };
  });
  throw error;
});

export default validateFields;
